import type { Locale } from '@/store/useLocaleStore'

type ThemeName = 'loolootech' | 'parich'

interface ThemeConfig {
  adminSidebarLogo: string
  adminSidebarBrandName: string
  chatAssistantProfilePicture: string
  locale: Locale
}

export const themes: Record<ThemeName, ThemeConfig> = {
  loolootech: {
    adminSidebarLogo: '/images/looloo-logo-without-text.svg',
    adminSidebarBrandName: '',
    chatAssistantProfilePicture: '/images/assistant-profile-picture.svg',
    locale: 'en',
  },
  parich: {
    adminSidebarLogo: '/images/parich/logo.png',
    adminSidebarBrandName: 'PARICH',
    chatAssistantProfilePicture: '/images/parich/assistant-profile-picture.svg',
    locale: 'th',
  },
}

export const activeTheme: ThemeName = 'parich'

export function useTheme(): ThemeConfig {
  return themes[activeTheme]
}
